import React from "react";
import { FaGraduationCap } from "react-icons/fa";

import "./education.css";

const Education = () => {
  return (
    <section id="education">
      <h5>Education details</h5>
      <h2>Education</h2>
      <div className="container education__container">
        <div className="education-details">
          <div className="item-1">
            <h2>
              <FaGraduationCap /> BE in Computer Science
            </h2>
            <h4>Sant Longowal Institute of Engineering & Technology</h4>
            <p>2021 - present</p>
          </div>
          <div className="item-2">
            <h2>
              <FaGraduationCap /> Diploma in Computer Science
            </h2>
            <h4>Sant Longowal Institute of Engineering & Technology</h4>
            <p>2018 - 2021</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
